
export interface Certification {
  id: string;
  name: string;
  issuer: string;
  date: string;
  expiry?: string;
  credentialId?: string;
  credentialURL?: string;
  skills: string[];
  description: string;
  featured?: boolean;
}

export const certifications: Certification[] = [
  {
    id: "cert-1",
    name: "Namaste JavaScript",
    issuer: "NamasteDev",
    date: "2023",
    credentialURL: "https://namastedev.com/aniketsk02/certificates/namaste-javascript",
    skills: ["JavaScript", "Closures", "Promises", "Event Loop", "Asynchronous JS"],
    description: "Advanced JavaScript concepts including execution context, lexical environment, closures, and asynchronous JavaScript patterns.",
    featured: true
  },
  {
    id: "cert-2",
    name: "Crack Frontend Interview",
    issuer: "NamasteDev",
    date: "2023",
    credentialURL: "https://namastedev.com/aniketsk02/certificates/namaste-interview",
    skills: ["Data Structures", "Algorithms", "System Design", "Problem Solving", "Interview Preparation"],
    description: "Comprehensive training on frontend interview preparation, covering data structures, algorithms, and system design for modern web applications."
  },
  {
    id: "cert-3",
    name: "Namaste React",
    issuer: "NamasteDev",
    date: "2023",
    credentialURL: "https://namastedev.com/aniketsk02/certificates/namaste-react",
    skills: ["React", "JSX", "Hooks", "Redux", "React Router", "Performance Optimization"],
    description: "In-depth React course covering core concepts, state management, routing, performance optimization, and building production-ready applications.",
    featured: true
  },
  {
    id: "cert-4",
    name: "Build Javascript applications using Typescript",
    issuer: "Microsoft",
    date: "2023",
    credentialURL: "https://learn.microsoft.com/api/achievements/share/en-us/AniketKasale-9814/24ZX58GV?sharingId=344178DBED3CCE07",
    skills: ["TypeScript", "JavaScript", "Type Safety", "Interfaces", "Generics"],
    description: "Official Microsoft certification on building robust JavaScript applications with TypeScript, covering type systems, interfaces, generics, and best practices.",
    featured: true
  },
  {
    id: "cert-5",
    name: "Discover the leader in you",
    issuer: "ASPIRE, The Institute Of Human Development",
    date: "Oct 2022",
    credentialId: "3897",
    skills: ["Leadership", "Communication", "Team Building", "Decision Making"],
    description: "Leadership development program focused on building essential leadership qualities, effective communication, and decision-making skills.",
    featured: true
  },
  {
    id: "cert-6",
    name: "Personality Development Course (SITP)",
    issuer: "ASPIRE, The Institute Of Human Development",
    date: "Dec 2022",
    credentialId: "4297",
    skills: ["Soft Skills", "Communication", "Confidence Building", "Public Speaking"],
    description: "Comprehensive personality development program designed to enhance interpersonal skills, communication abilities, and overall professional presence."
  },
  {
    id: "cert-7",
    name: "Student of the month",
    issuer: "ASPIRE, The Institute Of Human Development",
    date: "Nov 2022",
    skills: ["Academic Excellence", "Leadership", "Community Involvement"],
    description: "Recognition awarded for outstanding academic performance, leadership qualities, and positive contribution to the learning community."
  }
];
